import { render, staticRenderFns } from "./TopBar.vue?vue&type=template&id=2d4b1b7c&scoped=true&"
import script from "./TopBar.vue?vue&type=script&lang=js&"
export * from "./TopBar.vue?vue&type=script&lang=js&"
import style0 from "./TopBar.vue?vue&type=style&index=0&id=2d4b1b7c&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d4b1b7c",
  null
  
)

export default component.exports